const columnDepartment = [
  {
    title: "Chức vụ",
    dataIndex: "titles",
    scopedSlots: { customRender: "titles" },
    width: 200,
  },
  {
    title: "Tên",
    dataIndex: "users",
    scopedSlots: {
      customRender: "users",
    },
    width: 250,
  },
  {
    title: "Ngày tạo",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 150,
  },
  {
    title: "Cập nhật lần cuối",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 150,
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 50,
  },
];

export { columnDepartment };
